/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/components/modular-form/custom/MapPlaceholder.tsx
 * Release: 1.0.0 - Placeholder per mappa Google Maps
 * Data: 27/06/2025
 */

import React from 'react';
import { MapPin } from 'lucide-react';

interface MapPlaceholderProps {
  value?: any;
  onChange?: (value: any) => void;
  disabled?: boolean;
  required?: boolean;
}

export const MapPlaceholder: React.FC<MapPlaceholderProps> = ({
  disabled = false,
  required = false
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <MapPin className="w-4 h-4 text-zinc-400" />
        <label className="text-sm font-medium text-zinc-300">
          Mappa {required && <span className="text-red-400">*</span>}
        </label>
      </div>
      
      <div className="relative">
        <div className="w-full h-48 bg-zinc-800 border border-zinc-700 rounded-lg flex items-center justify-center">
          <div className="text-center text-zinc-500">
            <MapPin className="w-12 h-12 mx-auto mb-2 text-zinc-600" />
            <p className="text-sm">Mappa Google Maps</p>
            <p className="text-xs mt-1">Sarà visualizzata qui quando selezionerai un indirizzo</p>
          </div>
        </div>
        
        {disabled && (
          <div className="absolute inset-0 bg-zinc-900/50 rounded-lg flex items-center justify-center">
          </div>
        )}
      </div>
      
      <p className="text-xs text-zinc-500">
        La mappa interattiva verrà integrata nella Fase 2 con Google Maps API
      </p>
    </div>
  );
}; 